import {redirect} from "react-router";
import {queryClient} from "../services/query-client.js";
import {sessionQueryOptions, SESSION_QUERY_KEY} from "../services/session.js";
import {hasPermission} from "../utils/permission-matcher.js";

const loadSession = async () => {
    let session;
    try {
        session = await queryClient.ensureQueryData(sessionQueryOptions);
    } catch {
        session = null;
    }

    if (!session) {
        queryClient.removeQueries({queryKey: SESSION_QUERY_KEY});
        throw redirect("/");
    }

    return session;
};

const resolveStateRedirect = (session) => {
    if (session.adminLimitBypass) return "/admin-session";
    if (session.changePassword) return "/change-password";
    if (session.dataIsStale && !session.ignoredStaleData) return "/my-user";
    return null;
};

export const protectedLoader = async ({request}) => {
    const session = await loadSession();
    const {pathname} = new URL(request.url);
    const target = resolveStateRedirect(session);

    if (pathname.includes("/dev/") && !session.system) throw redirect("/404");

    if (target && !pathname.endsWith(target)) throw redirect(target);
    return session;
};

export const requirePermission = (required) => {
    const normalized = Array.isArray(required) ? required.join(",") : required;
    return async (args) => {
        const session = await protectedLoader(args);
        if (!hasPermission(session.permissions, normalized)) throw redirect("/401");
        return session;
    };
};

export const isLogged = async () => {
    try {
        const session = await queryClient.ensureQueryData(sessionQueryOptions);
        if (session) return redirect("/home");
    } catch {
        return null;
    }
    return null;
};
